import React, {useState} from "react";
import {Card, Nav, NavItem, NavLink, TabContent, TabPane, Button, CardBody, Form, CardHeader} from "reactstrap";
import {registerPlugin} from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import classnames from "classnames";

// import file
import ImportCsv from "./BulkComponents/ImportCsv";
import MapFields from "./BulkComponents/MapFields";
import ValidatedCsv from "./BulkComponents/ValidatedCsv";
import BulkActions from "./BulkComponents/BulkActions";
import BulkSummary from "./BulkComponents/BulkSummary";
import BulkSuccessfully from "./BulkComponents/BulkSuccessfully";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import {ToastContainer} from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useProfileData } from "../../../../Components/Hooks/UserHooks";
import CalculateRemainingDays from "../../../../Components/Common/CalculateRemainingDays";
import SubExpired from "../../../../Components/Common/subExpired";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const BulkOperation = () => {
    const [actionVisible, setActionVisible] = useState(false)
    const [actionSummary, setActionSummary] = useState(false)
    const [leadSummary, setLeadSummary] = useState([])
    const [files, setFiles] = useState([]);
    const [passedarrowSteps, setPassedarrowSteps] = useState([1]);
    const [activeArrowTab, setactiveArrowTab] = useState(4);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const [SelectedLabelText, setSelectedLabelText] = useState([])
    const [SelectedAssignLabelText, setSelectedAssignLabelText] = useState([])

    const [isDragging, setIsDragging] = useState(false);

    const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);
    const navigate = useNavigate();
    const { profileData } = useProfileData();
    const remainingDays = CalculateRemainingDays();

    function toggleArrowTab(tab) {
        if (activeArrowTab !== tab) {
            var modifiedSteps = [...passedarrowSteps, tab];

            if (tab >= 4 && tab <= 7) {
                setactiveArrowTab(tab);
                setPassedarrowSteps(modifiedSteps);
            }
        }
    }

    function toggleArrowTab(tab) {
        if (activeArrowTab !== tab) {
            const modifiedSteps = [...passedarrowSteps, tab];
            if (tab >= 4 && tab <= 10) {
                setactiveArrowTab(tab);
                setPassedarrowSteps(modifiedSteps);
            }
        }
    }

    const handleClose = () => {
        setIsExpiredModalOpen(false);
        navigate("/planPackage");
      };

    return (
        <>
         {remainingDays === 0 && isExpiredModalOpen && (
                    <SubExpired
                        onClose={handleClose}
                        profileData={profileData?.selectedPlanDetails?.planName}
                        remainingDays={remainingDays}
                    />
             )}
            <ToastContainer />
            <div>
                <div className="page-content sn-bulk-tabs-body-section">
                    <div className="container-fluid">
                        <div className="row">
                            <BreadCrumb title="Bulk Import" pageTitle="Bulk Import" />
                        </div>
                        <div className="row">
                            <Card className="sn-bulk-main-card-txt-sec">
                                <div className="sn-bulkimport-tabs-main">
                                    <CardBody className="form-steps" style={{height: "calc(100% - 220px)"}}>
                                        <Form>
                                            <div className="step-arrow-nav mb-4 mt-3">
                                                <Nav className="nav-pills custom-nav nav-justified" role="tablist">
                                                    <NavItem>
                                                        <NavLink
                                                            href="#"
                                                            id="steparrow-gen-info-tab"
                                                            className={classnames({
                                                                active: activeArrowTab === 4,
                                                                done: activeArrowTab <= 10 && activeArrowTab > 3,
                                                            })}
                                                            onClick={() => {
                                                                toggleArrowTab(4);
                                                            }}
                                                        >
                                                            <div className="sn-bulk-title-tabs">
                                                                <span className="ri-pages-line"></span>{" "}
                                                                <h6>Import CSV File</h6>
                                                            </div>
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink
                                                            href="#"
                                                            id="steparrow-description-info-tab"
                                                            className={classnames({
                                                                active: activeArrowTab === 5,
                                                                done: activeArrowTab <= 10 && activeArrowTab > 4,
                                                            })}
                                                            // onClick={() => {
                                                            //     toggleArrowTab(5);
                                                            // }}
                                                            onClick={(e) => {
                                                                e.preventDefault(); // Prevent default click behavior
                                                                if (files) { // Only allow click if file exists
                                                                    toggleArrowTab(5);
                                                                }
                                                            }}
                                                            style={{ pointerEvents: files.name ? 'auto' : 'none' }}
                                                        >
                                                            <div className="sn-bulk-title-tabs">
                                                               <span className="ri-map-2-line"></span>
                                                                <h6>Map Fields</h6>
                                                            </div>
                                                        </NavLink>
                                                    </NavItem>
                                                    {/* <NavItem>
                                                        <NavLink
                                                            href="#"
                                                            id="steparrow-additional-info-tab"
                                                            className={classnames({
                                                                active: activeArrowTab === 6,
                                                                done: activeArrowTab <= 10 && activeArrowTab > 5,
                                                            })}
                                                            onClick={() => {
                                                                toggleArrowTab(6);
                                                            }}
                                                        >
                                                            <div className="sn-bulk-title-tabs">
                                                                <span className="ri-checkbox-line"></span>
                                                                <h6> Validate CSV</h6>
                                                            </div>
                                                        </NavLink>
                                                    </NavItem> */}
                                                    <NavItem>
                                                        <NavLink
                                                            href="#"
                                                            id="steparrow-extra-info-tab"
                                                            className={classnames({
                                                                active: activeArrowTab === 7,
                                                                done: activeArrowTab <= 10 && activeArrowTab > 6,
                                                            })}
                                                            onClick={(e) => {
                                                                e.preventDefault(); // Prevent default click behavior
                                                                if (files) { // Only allow click if file exists
                                                                    toggleArrowTab(7);
                                                                }
                                                            }}
                                                            style={{ pointerEvents: actionVisible === true ? 'auto' : 'none' }}


                                                        >
                                                            <div className="sn-bulk-title-tabs">
                                                                <span className="ri-travesti-line"></span>
                                                                <h6>Actions</h6>
                                                            </div>
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink
                                                            href="#"
                                                            id="steparrow-new-tab1"
                                                            className={classnames({
                                                                active: activeArrowTab === 8,
                                                                done: activeArrowTab > 8,
                                                            })}
                                                            onClick={() => {
                                                                toggleArrowTab(8);
                                                            }}
                                                            style={{ pointerEvents: actionSummary === true ? 'auto' : 'none' }}
                                                        >
                                                            <div className="sn-bulk-title-tabs">
                                                                <span className="ri-file-list-3-line"></span>
                                                                <h6> Summary</h6>
                                                            </div>
                                                        </NavLink>
                                                    </NavItem>
                                                    {/* <NavItem>
                                                        <NavLink
                                                            href="#"
                                                            id="steparrow-new-tab2"
                                                            className={classnames({
                                                                active: activeArrowTab === 9,
                                                                done: activeArrowTab > 9,
                                                            })}
                                                            onClick={() => {
                                                                toggleArrowTab(9);
                                                            }}
                                                        >
                                                            <div className="sn-bulk-title-tabs">
                                                                <span className="ri-award-fill"></span>
                                                                <h6>Successfully</h6>
                                                            </div>
                                                        </NavLink>
                                                    </NavItem> */}
                                                </Nav>
                                            </div>
                                            <TabContent activeTab={activeArrowTab}>
                                                <ImportCsv isDragging={isDragging} files={files} setFiles={setFiles} toggleArrowTab={toggleArrowTab} activeArrowTab={activeArrowTab} setCsvHeaders={setCsvHeaders} />
                                                <MapFields setactiveArrowTab = {setactiveArrowTab} setIsDragging={setIsDragging} setFiles={setFiles} setCsvHeaders={setCsvHeaders} toggleArrowTab={toggleArrowTab} activeArrowTab={activeArrowTab} csvHeaders={csvHeaders} setActionVisible={setActionVisible} />
                                                {/* <ValidatedCsv toggleArrowTab={toggleArrowTab} activeArrowTab={activeArrowTab} /> */}
                                                <BulkActions
                                                    setActionSummary={setActionSummary}
                                                    setSelectedLabelText={setSelectedLabelText}
                                                    setSelectedAssignLabelText={setSelectedAssignLabelText}
                                                    isChecked={isChecked}
                                                    setIsChecked={setIsChecked}
                                                    setLeadSummary={setLeadSummary}
                                                    files={files}
                                                    toggleArrowTab={toggleArrowTab}
                                                    activeArrowTab={activeArrowTab} />

                                                <BulkSummary                                                  
                                                    SelectedLabelText={SelectedLabelText}
                                                    SelectedAssignLabelText={SelectedAssignLabelText}
                                                    isChecked={isChecked}
                                                    leadSummary={leadSummary} files={files}
                                                    toggleArrowTab={toggleArrowTab} activeArrowTab={activeArrowTab} />
                                                <BulkSuccessfully
                                                    toggleArrowTab={toggleArrowTab} activeArrowTab={activeArrowTab} />
                                            </TabContent>
                                        </Form>
                                    </CardBody>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BulkOperation;
